import { render } from "./TheNotFoundPage.vue?vue&type=template&id=b1b56980&scoped=true"
import script from "./TheNotFoundPage.vue?vue&type=script&lang=js"
export * from "./TheNotFoundPage.vue?vue&type=script&lang=js"

import "./TheNotFoundPage.vue?vue&type=style&index=0&id=b1b56980&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1b56980"]])

export default __exports__